import Nav1 from "./Nav1";
import Nav2 from "./Nav2";
const Header = () => {
  return (
    <div id="header">
      <Nav1 />
      <Nav2 />
    </div>
  );
};

export default Header;
